import '@naturehouse/design-system/components/atoms/date-field/DateField';
import '@naturehouse/design-system/components/molecules/calendar-week-days/CalendarWeekDays';
import '../../ui/web-components/searchBar/DestinationSearch';
import '../../ui/web-components/searchBar/SearchBar';
import '../calendar/webComponents/CalendarInput';
import '../calendar/webComponents/DatePickerCalendar';
import NavigationHelper from './NavigationHelper';
import '../../../css/views/homepage.pcss';

export default class HomepageModule {
    public initialize(): void {
        NavigationHelper.getInstance();
    }
}

(function homepageModuleInit(): void {
    const homepageModule: HomepageModule = new HomepageModule();
    homepageModule.initialize();
})();
